/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const WarehouseDispatchResponseModeEnum = {
    Ship: 'SHIP',
    Hold: 'HOLD',
    NotComing: 'NOT_COMING'
};
/**
 * Check if a given object implements the WarehouseDispatchResponse interface.
 */
export function instanceOfWarehouseDispatchResponse(value) {
    return true;
}
export function WarehouseDispatchResponseFromJSON(json) {
    return WarehouseDispatchResponseFromJSONTyped(json, false);
}
export function WarehouseDispatchResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}
export function WarehouseDispatchResponseToJSON(json) {
    return WarehouseDispatchResponseToJSONTyped(json, false);
}
export function WarehouseDispatchResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mode': value['mode'],
    };
}
